import React from 'react';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';

import useStyles from './styles';
import { connect } from 'react-redux';

const mapState = ({ auth: { user } }) => {
    return {
        loading: user.loading,
    };
};


const mapDispatch = (dispatch) => ({
    postAgreement: (payload) => dispatch.auth.postAgreementAsync(payload)
});

function Terms({postAgreement, loading}) {
    
    const classes = useStyles();
    const [state, setState] = React.useState({
        accepted: false
    });

    const handleAccept = (event) => {
        setState({ ...state, [event.target.name]: event.target.checked });
    };

    const handleContinue = () => {        
        postAgreement({mode: 'confirm', checked: state.accepted});
    }

    return (
        <Card className={classes.termsContent}>
            <CardActionArea>
                <CardContent>
                    <iframe title="termos" className={classes.iframeContent} src="https://www.cargill.com/page/business-notice-pt-br" />
                </CardContent>
            </CardActionArea>
            <CardActions>
                <Grid container alignItems="center">
                    <Grid item xs={12} md={10}>
                        <FormControlLabel
                            data-cy="accept-check"
                            id="accept-check"
                            control={<Checkbox disabled={loading} checked={state.accepted} onChange={handleAccept} name="accepted" />}
                            label="Eu li o Aviso de Informações Comerciais da Cargill."
                        />
                    </Grid>
                    <Grid item xs={12} md={2} className={classes.buttonContent}>
                        <Button
                            disabled={loading || !state.accepted}
                            onClick={handleContinue}
                            data-cy="continue-btn"
                            id="continue-btn"
                            className={classes.buttonContinue} 
                            variant="contained" color="primary">
                            Continuar
                        </Button>
                    </Grid>
                </Grid>
            </CardActions>
        </Card>
    );
}

export default connect(
    mapState,
    mapDispatch
)(Terms);